import React from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import { AddNotification } from "./AddNotification/AddNotification"
import { GlobalNotificationHome } from "./GlobalNotificationHome/GlobalNotificationHome"
import { UpdateNotification } from "./UpdateNotification/UpdateNotification"
import { DeleteNotification } from "./Modals/DeleteNotification"
import { getUserRoles } from "../../utils/validateToken"
import { useSelector } from "react-redux"

export const GlobalNotification = () => {
  const user = useSelector((state) => state.user)

  const isRoleOnlyRead = () => {
    const appRoles = getUserRoles(user.eAuthToken)
    if (appRoles && appRoles.length > 0) {
      return appRoles.includes("CGI.GlobalNotificationReader")
    }
    return false
  }

  return (
    <Routes>
      <Route path="/" element={<GlobalNotificationHome />} />
      {!isRoleOnlyRead() && (
        <>
          <Route path="/add" element={<AddNotification />} />
          <Route
            path="/edit/:notificationId"
            element={<UpdateNotification />}
          />
          <Route
            path="/delete/:notificationId"
            element={<DeleteNotification />}
          />
        </>
      )}
      <Route path="*" element={<Navigate replace to="/globalNotification" />} />
    </Routes>
  )
}
